import React, { RefObject } from 'react';
import mp4Video from '../../assets/images/bg/portfolio-access-animation-2-short.mp4';
import webmVideo from '../../assets/images/bg/portfolio-access-animation-2-short.webm';

interface AccessPageVideoProps {
  $videoElement: RefObject<HTMLVideoElement> | null;
}

function AccessPageVideo(props: AccessPageVideoProps): React.ReactElement {
  const { $videoElement } = props;

  return (
    <video
      ref={$videoElement}
      className="accessPage-video"
      width="100%"
      muted
      playsInline
      autoPlay={false}
      style={{
        visibility: 'hidden',
        opacity: 0,
        position: 'absolute',
        zIndex: -1,
      }}
    >
      <source src={webmVideo} type="video/webm" />
      <source src={mp4Video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
}

export default AccessPageVideo;
